import { DeviceInfo, Log, LogCommerce, LogLevel, UserDoc } from '@gooduncles/gu-app-schema';
import { errorObjectToString, getLocalStorageValue, sessionId } from 'src/utils/common';
import { LocalStorageKey } from 'src/utils/constants/ui-constants';

import { isLocal } from './config';
import { createLogCommerce } from './firebase/firebase-short-cut';

export class CommerceLogger {
  private static instance: CommerceLogger;
  private user: UserDoc | null;
  private publicIp: string;

  private constructor() {
    this.publicIp = 'unknown';
    this.user = null;
  }

  public static getInstance() {
    if (CommerceLogger.instance === undefined) {
      CommerceLogger.instance = new CommerceLogger();
    }
    return CommerceLogger.instance;
  }

  public setLoggerUser(user: UserDoc | null) {
    this.user = user;
  }

  public setPublicIp(ip: string) {
    this.publicIp = ip;
  }

  public getPublicIp() {
    return this.publicIp;
  }

  public logCommerce(
    message: string,
    option?: {
      level?: LogLevel;
      channel?: '4-앱-알림' | '4-앱-고객요청' | 'dev' | '4-1-앱-알림-신규';
      extraInfo?: Partial<Log<LogCommerce>['body']>;
      showBody?: boolean;
    }
  ) {
    const deviceInfo = getLocalStorageValue<DeviceInfo>(LocalStorageKey.deviceInfo);
    const path = window.location.pathname;
    const { level, channel, extraInfo, showBody } = option || {};

    const log: Log<LogCommerce> = {
      level: level ?? 'log',
      sessionId: sessionId(),
      publicIp: this.publicIp,
      message,
      slack: {
        channel,
        showBody,
      },
      body: {
        path,
        deviceId: deviceInfo?.tokenId ?? 'unknown',
        user: this.user,
        orderId: extraInfo?.orderId ?? null,
      },
    };

    if (!channel && !showBody) {
      delete log.slack;
    }

    return isLocal ? console.log(log.message) : createLogCommerce(log);
  }
}

export const logger = CommerceLogger.getInstance();

export const errorLogger = (error: Error | string) => {
  console.error(error);
  return logger.logCommerce(typeof error === 'string' ? error : errorObjectToString(error), { level: 'error' });
};
